import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";

const MenuItems = ({ itemId, menuId, options, anchorEl, ariaControl, handleClose }: any) => {
  return (
    <Menu
      id={itemId}
      anchorEl={anchorEl}
      onClose={handleClose}
      open={menuId === ariaControl}
      MenuListProps={{
        "aria-labelledby": ariaControl,
      }}
    >
      {options?.map(({ id, route, title }: any) => (
        <Link to={route} key={id}>
          <MenuItem onClick={handleClose}>{title}</MenuItem>
        </Link>
      ))}
    </Menu>
  );
};

export default MenuItems;
